import { Injectable } from '@angular/core';
import { Event, NavigationStart, Router } from '@angular/router';
import { GlobalStyle, Theme, ThemeService } from '../theme.service';
import { TokenKeeper } from '../tokenKeeper';

@Injectable({
  providedIn: 'root',
})
export class IsAdminService {
  get isAdmin() {
    return this.loadedApp === ADMIN_APP;
  }
  private loadedApp = APTITUDE_APP;
  private favIcon: HTMLLinkElement | null =
    document.querySelector('#app-favicon');
  private firstLoad = true;

  constructor(router: Router, private themeService: ThemeService) {
    router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        this.handleNavigationStartEvent(event);
      }
    });
  }

  private handleNavigationStartEvent(event: NavigationStart) {
    const appBeingLoaded = whichAppToLoad(this.stripQueryParams(event.url));
    const hasAppChanged = this.loadedApp !== appBeingLoaded;

    if (this.firstLoad || hasAppChanged) {
      this.setFavicon(appBeingLoaded.icon);
      this.themeService.setTheme(appBeingLoaded.theme);
      this.themeService.setGlobalStyles(appBeingLoaded.globalStyles);
    }
    this.firstLoad = false;
    this.loadedApp = appBeingLoaded;
  }

  private stripQueryParams(url: string) {
    return url.split('?')[0];
  }

  setFavicon(url: string) {
    if (this.favIcon) {
      this.favIcon.href = url;
    }
  }

  getAuthToken() {
    return this.isAdmin
      ? TokenKeeper.getAdminSingleton()
      : TokenKeeper.getPlatformSingleton();
  }
}

interface App {
  icon: string;
  theme: Theme;
  globalStyles: GlobalStyle;
}

const APTITUDE_APP: App = {
  icon: 'favicon.ico',
  theme: 'platform-green',
  globalStyles: 'platform',
};

const ADMIN_APP: App = {
  icon: 'admin_favicon.ico',
  theme: 'admin-blue',
  globalStyles: 'admin',
};

const VIZIENT_APP: App = {
  icon: 'viz_favicon.ico',
  theme: 'vizient-orange',
  globalStyles: 'vizient',
};

function whichAppToLoad(url: string) {
  switch (true) {
    case url.includes('admin'):
      return ADMIN_APP;
    case url.includes('vizient'):
      return VIZIENT_APP;
    default:
      return APTITUDE_APP;
  }
}
